import { render } from "./ConsultaImportaciones.vue?vue&type=template&id=09d898e6"
import script from "./ConsultaImportaciones.vue?vue&type=script&lang=js"
export * from "./ConsultaImportaciones.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__